import React from "react";
import { Navigate, Outlet } from "react-router-dom";

import { loadSessionToken } from "../../store/localStorage";

export const PrivateRoute = () => {
  const isAuthenticated = loadSessionToken();
  return isAuthenticated ? <Outlet /> : <Navigate to="/login" />;
};
